import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faYoutube as fabFaYoutube } from '@fortawesome/free-brands-svg-icons';

import AutoPlayVideo from 'Components/Media/Video/AutoPlayVideo';
import FluidImg from 'Components/Media/Image/FluidImg';

import 'Components/Banner/HowToGiftBanner/HowToGiftBanner.scss';
import 'Components/Modal/AccountModal.scss';

export default function HowToGiftBanner({ smallBanner, giftBannerHeadingTag, type }) {
  const [modalOpen, setModalOpen] = useState(false);
  const TagName = giftBannerHeadingTag;

  return (
    <React.Fragment>
      <div className={classNames('HowToGiftBanner', { 'HowToGiftBanner--small': smallBanner, 'HowToGiftBanner--large': !smallBanner })}>
        <div className="HowToGiftBanner__headingBtnContainer">
          <TagName className="HowToGiftBanner__heading">
            {type === 'gift-card' ?
              <FormattedMessage id="HowToGiftBanner.heading-gift-card" defaultMessage="How to Gift a Product" />
              :
              <FormattedMessage id="HowToGiftBanner.heading" defaultMessage="How to Gift a Game" />
            }
          </TagName>
          {smallBanner &&
            <div className="HowToGiftBanner__btnContainer">
              <Link to="/gift-guide" className="brand-link">
                <FormattedMessage id="HowToGiftBanner.link.large" defaultMessage="Back to Gift Guide" />
              </Link>
            </div>
          }
        </div>

        <div className="HowToGiftBanner__content">
          <div className="HowToGiftBanner__videoContainer">
            <div className="HowToGiftBanner__videoSpace">
              <FluidImg
                folder="assets/gift-guide"
                className="img-force-full"
                src="gift-guide-video-thumbnail.png"
                alt="How gift video thumbnail"
              />
              <button className="HowToGiftBanner__videoOverlay" onClick={() => { setModalOpen(!modalOpen); }}>
                <FontAwesomeIcon icon={fabFaYoutube} title="YouTube" className="HowToGiftBanner__videoIcon" />
              </button>
            </div>
          </div>
          <div className="HowToGiftBanner__points">
            <div className="HowToGiftBanner__mobilePoint">
              <FormattedMessage id="HowToGiftBanner.point.mobile" defaultMessage="Find out how to digitally gift a game in just a few easy steps." />
            </div>

            <div className="HowToGiftBanner__point">
              <div className="HowToGiftBanner__point__titleContainer">
                <div className="HowToGiftBanner__point__number">
                  1
                </div>
                <div className="HowToGiftBanner__point__title">
                  <FormattedMessage id="HowToGiftBanner.point.one.title" defaultMessage="Add to cart" />
                </div>
              </div>
              <div className="HowToGiftBanner__point__text">
                <FormattedMessage
                  id="HowToGiftBanner.point.one.text"
                  defaultMessage="Find the perfect gift and add it to your cart. Make sure you tick the box on the Checkout to 'Gift This Order'."
                />
              </div>
            </div>

            <div className="HowToGiftBanner__point">
              <div className="HowToGiftBanner__point__titleContainer">
                <div className="HowToGiftBanner__point__number">
                  2
                </div>
                <div className="HowToGiftBanner__point__title">
                  <FormattedMessage id="HowToGiftBanner.point.two.title" defaultMessage="Personalise Gift" />
                </div>
              </div>
              <div className="HowToGiftBanner__point__text">
                <FormattedMessage
                  id="HowToGiftBanner.point.two.text"
                  defaultMessage="Enter recipient details, write a personal message, choose a theme and set a date you want the gift to arrive."
                />
              </div>
            </div>

            <div className="HowToGiftBanner__point">
              <div className="HowToGiftBanner__point__titleContainer">
                <div className="HowToGiftBanner__point__number">
                  3
                </div>
                <div className="HowToGiftBanner__point__title">
                  <FormattedMessage id="HowToGiftBanner.point.three.title" defaultMessage="Complete order" />
                </div>
              </div>
              <div className="HowToGiftBanner__point__text">
                <FormattedMessage
                  id="HowToGiftBanner.point.three.text"
                  defaultMessage="Complete your purchase as normal, and relax! You can amend any details from your Account area should you need to."
                />
              </div>
            </div>
          </div>
        </div>

        {smallBanner &&
          <div className="HowToGiftBanner__mobileBtnContainer">
            <Link to="/gift-guide" className="brand-link">
              <FormattedMessage id="HowToGiftBanner.link.large" defaultMessage="Back to Gift Guide" />
            </Link>
          </div>
        }
      </div>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} className="account-modal account-modal--large">
        <ModalBody>
          <div className="account-modal-title">
            <FormattedMessage id="HowToGiftBanner.modal.heading" defaultMessage="How to Gift a Game" />
          </div>
          <div className="account-modal-form full-width">
            <div className="video-wrapper">
              <AutoPlayVideo width="100%" height="auto" src={'jr2hvMCQ8eo'} className="youtube-video" />
            </div>

            <div className="account-modal-form-buttons">
              <div className="form-button-container">
                <button className="btn btn-primary" onClick={() => setModalOpen(!modalOpen)}>
                  <FormattedMessage id="HowToGiftBanner.modal.button.close" defaultMessage="Close" />
                </button>
              </div>
            </div>
          </div>
        </ModalBody>

        <div className="close-button-container">
          <button aria-label="close" onClick={() => setModalOpen(!modalOpen)}>
            <FontAwesomeIcon icon={faXmark} title="Close modal" />
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

HowToGiftBanner.propTypes = {
  smallBanner: PropTypes.bool,
  giftBannerHeadingTag: PropTypes.string,
};

HowToGiftBanner.defaultProps = {
  smallBanner: false,
  giftBannerHeadingTag: 'h2',
};
